// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowRightLine from '../_raw/ui/icon_arrow_right_line.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowRightLine);
